<template>
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <template v-slot:activator="{ on }">
      <v-btn class="success" v-on="on" @click="checkEligibility">
        <v-icon left>person_add</v-icon>
        Add Agent
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <v-icon left>person_add</v-icon>
        <span class="headline">Add New Agent</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon large color="error">close</v-icon>
        </v-btn>
      </v-card-title>

      <v-container grid-list-md class="py-0">
        <v-card-text class="py-0">
          <v-form ref="add_agent_form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="newAgent.name"
              label="Name *"
              :rules="[(v) => !!v || 'Name is required']"
            ></v-text-field>
            <v-text-field
              type="number"
              v-model="newAgent.numbers_of_agent"
              label="Number of Agents *"
              :rules="[
                (v) => !!v || 'Number of Agents is required',
                (v) =>
                  (v && v <= maximumNumberOfAgentMembers) ||
                  `Number of Agents should be less than or equal to ${maximumNumberOfAgentMembers}`,
              ]"
            ></v-text-field>
            <v-text-field
              v-model="newAgent.code"
              label="Code *"
              :rules="[
                (v) => !!v || 'Code is required',
                (v) => /\b.{6}\b/g.test(v) || 'Code must be 6 characters',
              ]"
            ></v-text-field>
            <v-btn flat small color="primary" @click="generate">
              Generate Code
            </v-btn>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            :loading="loading"
            :disabled="loading || !valid"
            @click="save"
          >
            Add
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
  import api from "../../api/datadash";
  import { mapState } from "vuex";
  import generateCode from "../../utils/generateCode";
  export default {
    props: ["eligible", "maximumNumberOfAgentMembers"],
    data() {
      return {
        dialog: false,
        loading: false,
        valid: false,
        newAgent: {
          name: "",
          numbers_of_agent: null,
          code: "",
        },
        defaultItem: {
          name: "",
          numbers_of_agent: null,
          code: "",
        },
      };
    },
    computed: {
      ...mapState(["auth"]),
    },
    watch: {
      dialog(val) {
        val || this.close();
      },
    },
    methods: {
      close() {
        setTimeout(() => {
          this.dialog = false;
          this.newAgent = { ...this.defaultItem };
        }, 20);
      },
      async save() {
        await this.$refs.add_agent_form.validate();
        if (this.valid) {
          try {
            this.loading = true;

            const { data } = await api.storeData(
              this.auth.token,
              "agent-group",
              this.newAgent
            );

            if (data.error) {
              this.$emit("result", [data.errorMsg, "error"]);
            } else {
              this.$emit("result", ["Agent created successfully", "success"]);
              this.close();
            }

            this.loading = false;
          } catch (error) {
            this.loading = false;
          }
        }
      },
      checkEligibility() {
        if (!this.eligible) {
          this.$emit("result", [
            "The total number of Agents reached maximum limit",
            "error",
          ]);
          this.close();
        }
      },

      generate() {
        this.newAgent.code = generateCode();
      },
    },
  };
</script>
